// extracted by mini-css-extract-plugin
export default {"scrollToTop":"backToTop_scrollToTop__XEL-a","fadeIn":"backToTop_fadeIn__SHXdb","fadeAnimate":"backToTop_fadeAnimate__et+mG","ArrowUp":"backToTop_ArrowUp__6digp"};